import React, { Component } from 'react'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import CircularProgress from 'material-ui/CircularProgress';
import ReactTable from 'react-table'
import matchSorter from 'match-sorter'
import "react-table/react-table.css";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Chance from "chance";
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MultipleApprovals from './MultipleApprovals'
const CheckboxTable = checkboxHOC(ReactTable);
const chance = new Chance()
class ReportTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      currPageIndex: 0,
      // selection: [],
      // selectAll: false,
      // selectedData: []
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.columns.length) {
      let data = nextProps.data.map(data => {
        // const _id = chance.guid();
        const _id = nextProps.viewMode === "accountingReport" ? data.payment_request_id : data.payment_request_transaction_log_id;
        return {
          _id,
          ...data
        }
      })
      let pageIndex = nextProps.pageIndex;
      // this.setState({ data,selectedData:[] })
      this.setState({ data: data, currPageIndex: pageIndex })
    }
  }
  toggleSelection = (key, shift, row) => {
    let selection = [...this.props.selection];
    let selectedData = [...this.props.selectedData]

    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [
        ...selection.slice(0, keyIndex),
        ...selection.slice(keyIndex + 1)
      ];
      selectedData = [
        ...selectedData.slice(0, keyIndex),
        ...selectedData.slice(keyIndex + 1)
      ]
    } else {
      selection.push(key);
      selectedData.push(row)
    }
    // update the state
    this.props.updateSelected(selection, selectedData)
    // this.setState({ selection, selectedData });
  };

  toggleAll = () => {
    const selectAll = this.props.selectAll ? false : true
    const selection = new Set()
    const selectedData = []
    if (selectAll) {
      // we need to get at the internals of ReactTable
      const wrappedInstance = this.checkboxTable.getWrappedInstance()
      // the 'sortedData' property contains the currently accessible records based on the filter and sort
      const currentRecords = wrappedInstance.getResolvedState().sortedData;

      if(this.props.viewMode === "accountingReport") {
        currentRecords.forEach(item => {
          if(item._original.accounting_status === 'Unaccounted') {
            if(!selection.has(item._original.payment_request_id)) {
              selectedData.push(item._original)
            }
            selection.add(item._original.payment_request_id);
          }
        });
      } else {
        // we just push all the IDs onto the selection array
        currentRecords.forEach(item => {
          if(!selection.has(item._original.payment_request_transaction_log_id)) {
            selectedData.push(item._original)
          }
          selection.add(item._original.payment_request_transaction_log_id)
        });
      }
    }
    this.props.updateSelected(Array.from(selection), selectedData, selectAll)
    // this.setState({ selectAll, selection, selectedData });
  };

  isSelected = key => {
    return this.props.selection.includes(key);
  };

   handleOk(){
   this.props.handleOk()
  }
  render() {
    if (this.props.columns.length) {
      const { toggleSelection, toggleAll, isSelected } = this;
      const { selectAll } = this.props;
      const checkboxProps = {
        selectAll,
        isSelected,
        toggleSelection,
        toggleAll,
        selectType: "checkbox",
        getTrProps: (s, r) => {
          if (r !== undefined) {
            const style = {
              backgroundColor: "inherit",
              color: "inherit",
            };
            if('payment_request_transaction_log_id' in r.original) {
              const selected = this.isSelected(r.original.payment_request_transaction_log_id);
              style.backgroundColor = selected ? "lightgreen" : "inherit";
            }

            if(r.original.all_data && r.original.all_data.payment_request.vendor_deactivate == 1) {
              style.color = "#FF6347";
            }

            return {
              style
            };
          } else {
            return {};
          }
        }
      }

      return (
        <MuiThemeProvider muiTheme={getMuiTheme()}>
          <CheckboxTable
            style={{ textAlign: "center", margin: '20px' }}
            ref={r => (this.checkboxTable = r)}
            data={this.state.data}
            filterable
            defaultFilterMethod={(filter, row) =>
              String(row[filter.id]) === filter.value}
            columns={this.props.columns.map((col) => ({
              Header: col.Header,
              id: col.key,
              accessor: col.key,
              filterMethod: (filter, rows) => {
                // for allowing the filter to catch rows having invoice numbers with links
                // in case of links, the props.children value has the invoice number
                if(col.key === 'invoice_number'){
                  return matchSorter(rows, filter.value, { keys: [col.key, col.key + ".props.children"] })
                }
                else
                  return matchSorter(rows, filter.value, { keys: [col.key] })
              },
              filterAll: true,
              width: 150
            }))}
            defaultPageSize={10}
            page={this.state.currPageIndex}
            onPageChange={(pageIndex)=>{ this.props.tablePageChangehandler(pageIndex); this.setState({currPageIndex: pageIndex})}}
            className="-striped -highlight"
            {...checkboxProps}
          />
          <MultipleApprovals 
            data={this.props.selectedData} 
            handleOk={this.handleOk.bind(this)} 
            viewMode={this.props.viewMode}
          />
        </MuiThemeProvider >
      )
    }
    else {
      return (
        <MuiThemeProvider>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularProgress size={60} thickness={7} />
          </div>
        </MuiThemeProvider>
      )
    }
  }
}
export default ReportTable



// WEBPACK FOOTER //
// ./src/components/SelectTable.js